import SectionHeading from '@/pages/home/components/SectionHeading';
import { topicIndex } from '@/mocks/home';

export default function TopicIndexSection() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <SectionHeading
          eyebrow="Index"
          title="黑历史分类索引"
          desc="按题材把人物负面事件拆成八个常用分类，不确定该从哪看起时，先从题材进入对应的档案集合，再挑人物顺着时间线往下看。"
        />

        <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {topicIndex.map((topic) => (
            <a
              key={topic.name}
              href="#archive"
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-background-200/70 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                <i className={`${topic.icon} text-lg`} />
              </span>
              <span className="mt-4 flex items-baseline gap-2">
                <span className="font-heading text-base font-bold text-foreground-950">
                  {topic.name}
                </span>
                <span className="font-label text-xs text-foreground-500">{topic.count} 条</span>
              </span>
              <span className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-[13px]">
                {topic.desc}
              </span>
              <span className="mt-3 hidden items-center gap-1 font-label text-xs text-primary-600 md:inline-flex">
                进入分类
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}